import Marionette from 'backbone.marionette';
import countyItemViewTmpl from '../templates/members_browse_filters_county_itemview.tpl';
export default Marionette.ItemView.extend({
  template: countyItemViewTmpl,
  tagName: "option",
  onRender: function () {
    this.$el.attr('value', this.model.get("cntyName"));
  }
});